class YoutubeEmbed {
  constructor(outerClass = 'faq-media-carousel') {
    this.outerClass = outerClass;
    this.ytRegex = /^(?:https?:\/\/)?(?:(?:www\.|m\.)?youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[?&].*)?$/;
    this.ytInlineRegex = /(?:https?:\/\/)?(?:(?:www\.|m\.)?youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:[?&][^\s<"]*)?/g;
  }

  buildEmbed(videoId) {
    const outer = document.createElement('div');
    outer.className = this.outerClass;
    const inner = document.createElement('div');
    inner.className = 'embed-responsive embed-responsive-16by9';
    const iframe = document.createElement('iframe');
    iframe.className = 'embed-responsive-item';
    iframe.src = 'https://www.youtube.com/embed/' + videoId;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    inner.appendChild(iframe);
    outer.appendChild(inner);
    return outer;
  }

  initInContainer(container) {
    if (!container) return;

    // Caso 1: div placeholder inseriti dal paste handler TinyMCE
    container.querySelectorAll('.youtube-video-placeholder').forEach((el) => {
      const videoId = el.getAttribute('data-youtube-id');
      if (videoId) el.replaceWith(this.buildEmbed(videoId));
    });

    // Caso 2: <a href="...youtube..."> inseriti dal link button
    container.querySelectorAll('a[href]').forEach((a) => {
      const match = (a.getAttribute('href') || '').match(this.ytRegex);
      if (match) a.replaceWith(this.buildEmbed(match[1]));
    });

    // Caso 3: URL YouTube come testo plain in un <p>
    container.querySelectorAll('p').forEach((p) => {
      if (p.querySelector('iframe')) return;

      const walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null, false);
      const textNodes = [];
      let node;
      while ((node = walker.nextNode())) textNodes.push(node);

      textNodes.forEach((textNode) => {
        this.ytInlineRegex.lastIndex = 0;
        if (!this.ytInlineRegex.test(textNode.textContent)) return;

        const text = textNode.textContent;
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        this.ytInlineRegex.lastIndex = 0;

        while ((match = this.ytInlineRegex.exec(text)) !== null) {
          if (match.index > lastIndex) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
          }
          fragment.appendChild(this.buildEmbed(match[1]));
          lastIndex = match.index + match[0].length;
        }
        if (lastIndex < text.length) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        textNode.parentNode.replaceChild(fragment, textNode);
      });
    });
  }
}

export default YoutubeEmbed;
